import HeightInputLabel from './HeightInputLabel';

export default HeightInputLabel;
